import { $util } from "../../../helper";

const getImageUrlInfo = imageUrl => {
  return new Promise((resolve, reject) => {
    fetch(imageUrl)
      .then(res => {
        return res.blob();
      })
      .then(resBlob => {
        const imageUrl = URL.createObjectURL(resBlob);
        const imgObj = new Image();

        imgObj.onload = () => {
          const type = resBlob.type ? resBlob.type.split("/")[1] : "";
          const large = resBlob.size ? (resBlob.size / 1024 / 1024).toFixed(2) : 0;
          resolve({
            width: imgObj.width,
            height: imgObj.height,
            type,
            large: large
          });
        };

        imgObj.src = imageUrl;
      })
      .catch(reject);
  });
};

const getInfoTip = async info => {
  const { id, name, shortName, enName, shortEnName, country, schoolBadge } = info;
  const warningTipItem = [];
  // 校验学校中英文是否全为空
  if (!name && !enName) {
    warningTipItem.push({ type: 1, tip: "SCHOOL_FULL_NAME_CAN_NOT_EMPTY" });
  }
  // 校验学校中文全称存在，中文简称不可为空
  if (name && !shortName) {
    warningTipItem.push({
      type: 2,
      tip: "SCHOOL_SHORT_NAME_ZH"
    });
  }
  // 校验学校英文全称存在，英文简称不可为空
  if (enName && !shortEnName) {
    warningTipItem.push({
      type: 2,
      tip: "SCHOOL_SHORT_NAME_EN"
    });
  }
  // 校验学校国家不可为空
  if (!country) {
    warningTipItem.push({
      type: 2,
      tip: "SCHOOL_COUNTRY"
    });
  }
  // 校验校徽是否存在
  if (!schoolBadge) {
    warningTipItem.push({
      type: 2,
      tip: "SCHOOL_BADGE"
    });
  } else {
    try {
      const badgeUrl = $util.getCdnUrl(schoolBadge);
      // 校验校徽格式是否符合要求
      const res = await getImageUrlInfo(badgeUrl);
      const { width, height, type, large } = res;
      // 尺寸
      if (!(width === 800 && height === 800)) {
        warningTipItem.push({
          type: 1,
          tip: "VERIFY_SCHOOL_BADGE_SIZE"
        });
      }
      // 大小
      if (large > 1) {
        warningTipItem.push({
          type: 1,
          tip: "VERIFY_SCHOOL_BADGE_LARGE"
        });
      }
      // 格式
      if (!type.includes("png")) {
        warningTipItem.push({
          type: 1,
          tip: "VERIFY_SCHOOL_BADGE_FORMATS"
        });
      }
    } catch (error) {
      console.log(error);
    }
  }
  return { id, warningTipItem };
};

const verifyCurInfo = info => {
  const promiseList = [];
  for (let item of info) {
    promiseList.push(getInfoTip(item));
  }
  return Promise.all(promiseList);
};

export default verifyCurInfo;



// WEBPACK FOOTER //
// ./src/components/common/teamInfo/verifySchoolInfo.js